// src/pages/admin/PainelParcelamentos.js

import React, { useEffect, useState, useMemo } from "react"
import axios from "axios"
import {
  FaMoneyBillWave, FaHourglassHalf, FaCheckCircle,
  FaExclamationTriangle, FaFileDownload, FaWhatsapp, FaFilter,
  FaLayerGroup, FaChartBar, FaChevronDown, FaChevronUp,
  FaExternalLinkAlt, FaEdit, FaSave, FaTimes, FaTrash, FaExclamationCircle,
  FaClock, FaTicketAlt, FaSearch, FaPaperPlane,
} from "react-icons/fa"

const API = "https://api.ticketdovaqueiro.com/api"

const C = {
  bg:         "#121212",
  card:       "#1a1a1a",
  card2:      "#1e1e1e",
  card3:      "#252525",
  input:      "#2a2a2a",
  border:     "rgba(255,255,255,0.08)",
  borderGold: "rgba(255,204,0,0.25)",
  gold:       "#ffcc00",
  goldDark:   "#e6b800",
  text:       "#e0e0e0",
  muted:      "#9e9e9e",
  green:      "#4caf50",
  blue:       "#3b82f6",
  red:        "#ef4444",
}

const STATUS_CFG = {
  em_andamento: { label: "Em andamento", color: C.blue,  bg: "rgba(59,130,246,0.12)" },
  concluido:    { label: "Concluído",    color: C.green, bg: "rgba(76,175,80,0.12)"  },
  inadimplente: { label: "Inadimplente", color: C.red,   bg: "rgba(239,68,68,0.12)"  },
  cancelado:    { label: "Cancelado",    color: C.muted, bg: "rgba(156,163,175,0.1)" },
}

const PARC_STATUS_CFG = {
  pendente:  { label: "Pendente",  color: C.blue,  bg: "rgba(59,130,246,0.12)"  },
  paga:      { label: "Paga",      color: C.green, bg: "rgba(76,175,80,0.12)"   },
  vencida:   { label: "Vencida",   color: C.red,   bg: "rgba(239,68,68,0.12)"   },
  cancelada: { label: "Cancelada", color: C.muted, bg: "rgba(156,163,175,0.08)" },
}

// ── CardResumo ────────────────────────────────────────────────────────────────
function CardResumo({ titulo, valor, icone, cor }) {
  return (
    <div style={{
      background: C.card, border: `1px solid ${C.border}`,
      borderLeft: `3px solid ${cor}`, borderRadius: 12,
      padding: "18px 20px", display: "flex", flexDirection: "column", gap: 8,
    }}>
      <div style={{ color: cor, fontSize: 22 }}>{icone}</div>
      <p style={{ fontSize: 12, color: C.muted, margin: 0, textTransform: "uppercase", letterSpacing: "0.5px" }}>{titulo}</p>
      <p style={{ fontSize: 22, fontWeight: 700, color: cor, margin: 0 }}>{valor}</p>
    </div>
  )
}

// ── SubTabelaParcelas ─────────────────────────────────────────────────────────
function SubTabelaParcelas({
  parcelas = [], nomeVaqueiro, whatsapp, nomeEvento,
  pedidoParceladoId, statusParcelamento,
  editVenc, setEditVenc, onSalvarVenc, salvandoVenc,
  onCancelar, cancelando,
  onCobrarVencida, enviandoCobr = {}, cobradoOk = {},
}) {
  const fmt = (v) => `R$ ${Number(v || 0).toFixed(2)}`
  const [confirmandoCancel, setConfirmandoCancel] = useState(false)
  // Mesmo um pedido concluído pode precisar de baixa administrativa (ex.: teste
  // ou pedido já reembolsado). O backend preserva as parcelas pagas como histórico.
  const podeCancelar = statusParcelamento !== "cancelado"
  const pedidoQuitado = statusParcelamento === "concluido"

  return (
    <div style={{
      margin: "0 8px 16px",
      background: C.card3,
      border: `1px solid ${C.borderGold}`,
      borderRadius: 10,
      overflow: "hidden",
    }}>
      <div style={{
        padding: "10px 16px", borderBottom: `1px solid ${C.border}`,
        display: "flex", alignItems: "center", gap: 8,
        background: "rgba(255,204,0,0.04)",
      }}>
        <FaLayerGroup style={{ color: C.gold, fontSize: 13 }} />
        <span style={{ color: C.gold, fontWeight: 700, fontSize: 13 }}>
          Detalhes das parcelas
        </span>
        <span style={{ color: C.muted, fontSize: 12, marginLeft: 4 }}>
          — {nomeEvento}
        </span>
      </div>

      <div style={{ overflowX: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
          <thead>
            <tr style={{ background: "rgba(255,255,255,0.03)" }}>
              {["Parcela", "Vencimento", "Valor", "Status", "Boleto", "WhatsApp", "Alterar Venc."].map(h => (
                <th key={h} style={{
                  padding: "9px 14px", textAlign: "left",
                  color: C.muted, fontWeight: 600, fontSize: 11,
                  textTransform: "uppercase", letterSpacing: "0.4px",
                  borderBottom: `1px solid ${C.border}`, whiteSpace: "nowrap",
                }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {parcelas.map((p, idx) => {
              const st = PARC_STATUS_CFG[p.status] || PARC_STATUS_CFG.pendente
              const vencStr = new Date(p.vencimento).toLocaleDateString("pt-BR")
              const isEditing =
                editVenc?.pedidoParceladoId === pedidoParceladoId &&
                editVenc?.numeroParcela === p.numero
              const podeEditar = p.status === "pendente" || p.status === "vencida"

              const msgWpp = encodeURIComponent(
                `Olá ${nomeVaqueiro}, sua parcela ${p.numero}/${parcelas.length} da inscrição em *${nomeEvento}* vence em *${vencStr}*.\n\n` +
                `💰 Valor: *${fmt(p.valor)}*\n\n` +
                (p.boletoUrl
                  ? `🔗 Acesse o boleto: ${p.boletoUrl}`
                  : `📱 Acesse o boleto pelo app Ticket do Vaqueiro.`)
              )

              return (
                <tr key={p.numero} style={{
                  borderBottom: `1px solid ${C.border}`,
                  background: idx % 2 === 0 ? "transparent" : "rgba(255,255,255,0.015)",
                }}>
                  <td style={{ padding: "10px 14px" }}>
                    <span style={{ fontWeight: 800, color: C.gold, fontSize: 14 }}>{p.numero}</span>
                    <span style={{ color: C.muted, fontSize: 11 }}>/{parcelas.length}</span>
                  </td>

                  <td style={{
                    padding: "10px 14px",
                    color: p.status === "vencida" ? C.red : C.text,
                    whiteSpace: "nowrap", fontWeight: 500,
                  }}>
                    {vencStr}
                    {p.status === "paga" && p.dataPagamento && (
                      <div style={{ fontSize: 10, color: C.green, marginTop: 2 }}>
                        Pago em {new Date(p.dataPagamento).toLocaleDateString("pt-BR")}
                      </div>
                    )}
                  </td>

                  <td style={{ padding: "10px 14px", color: C.text, fontWeight: 700 }}>
                    {fmt(p.valor)}
                  </td>

                  <td style={{ padding: "10px 14px" }}>
                    <span style={{
                      background: st.bg, color: st.color,
                      padding: "2px 9px", borderRadius: 5,
                      fontSize: 11, fontWeight: 600, whiteSpace: "nowrap",
                    }}>{st.label}</span>
                  </td>

                  <td style={{ padding: "10px 14px" }}>
                    {p.boletoUrl ? (
                      <a href={p.boletoUrl} target="_blank" rel="noopener noreferrer"
                        onClick={e => e.stopPropagation()}
                        style={{
                          display: "inline-flex", alignItems: "center", gap: 5,
                          color: C.gold, fontSize: 12, fontWeight: 600,
                          textDecoration: "none", padding: "4px 10px",
                          border: `1px solid ${C.borderGold}`, borderRadius: 5,
                        }}>
                        <FaExternalLinkAlt size={9} /> Ver boleto
                      </a>
                    ) : <span style={{ color: C.muted, fontSize: 11 }}>—</span>}
                  </td>

                  <td style={{ padding: "10px 14px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                      {whatsapp ? (
                        <a href={`https://wa.me/55${whatsapp.replace(/\D/g, "")}?text=${msgWpp}`}
                          target="_blank" rel="noopener noreferrer"
                          onClick={e => e.stopPropagation()}
                          title={`Cobrar parcela ${p.numero} via WhatsApp`}
                          style={{
                            display: "inline-flex", alignItems: "center", justifyContent: "center",
                            width: 30, height: 30, borderRadius: 6,
                            background: "rgba(76,175,80,0.15)", color: C.green, textDecoration: "none",
                          }}>
                          <FaWhatsapp size={14} />
                        </a>
                      ) : <span style={{ color: C.muted }}>—</span>}

                      {/* Botão de cobrança de vencida — só aparece para parcelas vencidas */}
                      {p.status === "vencida" && whatsapp && (() => {
                        const key   = `${pedidoParceladoId}_${p.numero}`
                        const send  = enviandoCobr[key]
                        const ok    = cobradoOk[key]
                        return (
                          <button
                            onClick={(e) => { e.stopPropagation(); onCobrarVencida(pedidoParceladoId, p.numero) }}
                            disabled={send}
                            title="Enviar cobrança de parcela vencida via WhatsApp"
                            style={{
                              display: "inline-flex", alignItems: "center", justifyContent: "center",
                              width: 30, height: 30, borderRadius: 6, border: "none",
                              background: ok
                                ? "rgba(76,175,80,0.2)"
                                : "rgba(239,68,68,0.15)",
                              color: ok ? C.green : C.red,
                              cursor: send ? "not-allowed" : "pointer",
                              opacity: send ? 0.6 : 1,
                              transition: "all 0.2s",
                              flexShrink: 0,
                            }}
                          >
                            {send
                              ? <div style={{ width: 10, height: 10, border: `2px solid ${C.red}`, borderTopColor: "transparent", borderRadius: "50%", animation: "spin 0.7s linear infinite" }} />
                              : ok
                                ? <span style={{ fontSize: 12 }}>✓</span>
                                : <FaPaperPlane size={11} />
                            }
                          </button>
                        )
                      })()}
                    </div>
                  </td>

                  <td style={{ padding: "10px 14px" }} onClick={e => e.stopPropagation()}>
                    {podeEditar && !isEditing && (
                      <button
                        onClick={() => setEditVenc({
                          pedidoParceladoId,
                          numeroParcela: p.numero,
                          novaData: new Date(p.vencimento).toISOString().slice(0, 10),
                        })}
                        style={{
                          display: "inline-flex", alignItems: "center", gap: 5,
                          background: "transparent", border: `1px solid ${C.border}`,
                          borderRadius: 5, padding: "4px 10px",
                          color: C.muted, fontSize: 11, cursor: "pointer",
                        }}>
                        <FaEdit size={10} /> Alterar
                      </button>
                    )}
                    {isEditing && (
                      <div style={{ display: "flex", alignItems: "center", gap: 5, flexWrap: "wrap" }}>
                        <input
                          type="date"
                          value={editVenc.novaData}
                          onChange={e => setEditVenc({ ...editVenc, novaData: e.target.value })}
                          style={{
                            padding: "3px 8px", background: C.input,
                            border: `1px solid ${C.borderGold}`,
                            borderRadius: 5, color: C.text, fontSize: 12, outline: "none",
                          }}
                        />
                        <button onClick={onSalvarVenc} disabled={salvandoVenc}
                          title="Confirmar nova data"
                          style={{
                            display: "inline-flex", alignItems: "center", justifyContent: "center",
                            width: 28, height: 28, borderRadius: 5,
                            background: "rgba(76,175,80,0.2)", border: "none",
                            color: C.green, cursor: "pointer", opacity: salvandoVenc ? 0.5 : 1,
                          }}>
                          {salvandoVenc ? "…" : <FaSave size={11} />}
                        </button>
                        <button onClick={() => setEditVenc(null)} title="Cancelar"
                          style={{
                            display: "inline-flex", alignItems: "center", justifyContent: "center",
                            width: 28, height: 28, borderRadius: 5,
                            background: "rgba(239,68,68,0.15)", border: "none",
                            color: C.red, cursor: "pointer",
                          }}>
                          <FaTimes size={11} />
                        </button>
                      </div>
                    )}
                    {p.status === "paga" && (
                      <span style={{ color: C.green, fontSize: 11, fontWeight: 600 }}>✓ Paga</span>
                    )}
                    {p.status === "cancelada" && (
                      <span style={{ color: C.muted, fontSize: 11 }}>Cancelada</span>
                    )}
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>

      {/* ── Rodapé: botão cancelar pedido ── */}
      {podeCancelar && (
        <div style={{
          padding: "12px 16px",
          borderTop: `1px solid ${C.border}`,
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          gap: 10,
          background: "rgba(239,68,68,0.03)",
        }}>
          {!confirmandoCancel ? (
            <button
              onClick={() => setConfirmandoCancel(true)}
              style={{
                display: "inline-flex", alignItems: "center", gap: 7,
                background: "transparent",
                border: `1px solid rgba(239,68,68,0.4)`,
                borderRadius: 6, padding: "6px 14px",
                color: C.red, fontSize: 12, fontWeight: 600,
                cursor: "pointer", transition: "all 0.2s",
              }}
            >
              <FaTrash size={10} /> Cancelar pedido
            </button>
          ) : (
            <div style={{
              display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap",
              padding: "8px 12px",
              background: "rgba(239,68,68,0.08)",
              border: `1px solid rgba(239,68,68,0.3)`,
              borderRadius: 8,
            }}>
              <FaExclamationCircle style={{ color: C.red, flexShrink: 0 }} />
              <span style={{ color: "#f87171", fontSize: 12, flex: 1 }}>
                {pedidoQuitado ? (
                  <>
                    Este pedido já está <strong>quitado</strong>. O cancelamento <strong>não faz reembolso automático</strong>;
                    use apenas para teste, correção administrativa ou após reembolso. As senhas serão liberadas. Confirma?
                  </>
                ) : (
                  <>
                    Isso cancelará os <strong>boletos ainda em aberto</strong> na Asaas e liberará as senhas. Confirma?
                  </>
                )}
              </span>
              <button
                onClick={() => { setConfirmandoCancel(false); onCancelar(pedidoParceladoId, nomeVaqueiro); }}
                disabled={cancelando}
                style={{
                  display: "inline-flex", alignItems: "center", gap: 5,
                  background: C.red, border: "none", borderRadius: 5,
                  padding: "5px 14px", color: "#fff",
                  fontSize: 12, fontWeight: 700, cursor: "pointer",
                  opacity: cancelando ? 0.6 : 1,
                }}
              >
                {cancelando ? "Cancelando…" : "Sim, cancelar"}
              </button>
              <button
                onClick={() => setConfirmandoCancel(false)}
                disabled={cancelando}
                style={{
                  display: "inline-flex", alignItems: "center", gap: 5,
                  background: "transparent",
                  border: `1px solid ${C.border}`,
                  borderRadius: 5, padding: "5px 12px",
                  color: C.muted, fontSize: 12, cursor: "pointer",
                }}
              >
                Não
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  )
}

// ── Componente principal ──────────────────────────────────────────────────────
export default function PainelParcelamentos() {
  const [eventos,           setEventos]           = useState([])
  const [eventoSelecionado, setEventoSelecionado] = useState("")
  const [dados,             setDados]             = useState(null)
  const [loading,           setLoading]           = useState(false)
  const [loadingEventos,    setLoadingEventos]    = useState(true)
  const [erro,              setErro]              = useState("")
  const [filtroStatus,      setFiltroStatus]      = useState("todos")
  const [filtroCategoria,   setFiltroCategoria]   = useState("todas")
  const [busca,             setBusca]             = useState("")
  const [expandidoId,       setExpandidoId]       = useState(null)
  const [editVenc,          setEditVenc]          = useState(null)
  const [salvandoVenc,      setSalvandoVenc]      = useState(false)
  const [erroVenc,          setErroVenc]          = useState("")
  const [enviandoCobr,      setEnviandoCobr]      = useState({})   // { "ppId_nParcela": true }
  const [cobradoOk,         setCobradoOk]         = useState({})   // idem, limpo após 3s
  const [cancelandoId,      setCancelandoId]      = useState(null)   // pedidoParceladoId em cancelamento

  const eventoAtual = eventos.find(ev => ev._id === eventoSelecionado)

  useEffect(() => {
    const fetchEventos = async () => {
      try {
        const token = localStorage.getItem("token")
        const { data } = await axios.get(`${API}/events`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        setEventos(data || [])
      } catch (err) {
        console.error("Erro ao carregar eventos:", err)
      } finally {
        setLoadingEventos(false)
      }
    }
    fetchEventos()
  }, [])

  useEffect(() => {
    if (!eventoSelecionado) { setDados(null); setExpandidoId(null); return }
    buscarDados(eventoSelecionado)
  }, [eventoSelecionado])

  const buscarDados = async (eventoId) => {
    setLoading(true); setErro(""); setDados(null); setExpandidoId(null)
    try {
      const token = localStorage.getItem("token")
      const { data } = await axios.get(
        `${API}/relatorios/financeiro/${eventoId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      )
      setDados(data)
    } catch (err) {
      setErro("Não foi possível carregar os dados deste evento.")
    } finally {
      setLoading(false)
    }
  }

  const exportarCSV = () => {
    if (!eventoSelecionado) return
    const token = localStorage.getItem("token")
    window.open(`${API}/relatorios/parcelados/${eventoSelecionado}/exportar?token=${token}`, "_blank")
  }

  const toggleExpand = (id) => {
    setExpandidoId(prev => prev === id ? null : id)
    setEditVenc(null)
  }

  const alterarVencimento = async () => {
    if (!editVenc) return
    setSalvandoVenc(true)
    setErroVenc("")
    try {
      const token = localStorage.getItem("token")
      await axios.put(
        `${API}/pagamento/asaas/parcela/alterar-vencimento`,
        {
          pedidoParceladoId: editVenc.pedidoParceladoId,
          numeroParcela:     editVenc.numeroParcela,
          novaData:          editVenc.novaData,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      setEditVenc(null)
      buscarDados(eventoSelecionado)
    } catch (err) {
      setErroVenc(err?.response?.data?.error || "Erro ao alterar vencimento. Tente novamente.")
    } finally {
      setSalvandoVenc(false)
    }
  }

  const enviarCobrancaVencida = async (pedidoParceladoId, numeroParcela) => {
    const key = `${pedidoParceladoId}_${numeroParcela}`
    setEnviandoCobr(prev => ({ ...prev, [key]: true }))
    setErroVenc("")
    try {
      const token = localStorage.getItem("token")
      await axios.post(
        `${API}/pagamento/asaas/parcela/cobrar-vencida`,
        { pedidoParceladoId, numeroParcela },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      setCobradoOk(prev => ({ ...prev, [key]: true }))
      // Limpa o ícone de sucesso após 3 segundos
      setTimeout(() => setCobradoOk(prev => {
        const next = { ...prev }; delete next[key]; return next
      }), 3000)
    } catch (err) {
      setErroVenc(
        err?.response?.data?.error ||
        `Erro ao enviar cobrança da parcela ${numeroParcela}.`
      )
    } finally {
      setEnviandoCobr(prev => ({ ...prev, [key]: false }))
    }
  }

  const cancelarPedidoParcelado = async (pedidoParceladoId, nomeVaqueiro) => {
    setCancelandoId(pedidoParceladoId)
    setErroVenc("")
    try {
      const token = localStorage.getItem("token")
      const { data } = await axios.delete(
        `${API}/pagamento/asaas/parcelado/${pedidoParceladoId}/cancelar`,
        { headers: { Authorization: `Bearer ${token}` } }
      )
      setExpandidoId(null)
      buscarDados(eventoSelecionado)
    } catch (err) {
      setErroVenc(err?.response?.data?.error || `Erro ao cancelar pedido de ${nomeVaqueiro}.`)
    } finally {
      setCancelandoId(null)
    }
  }

  const fmt = (v) => `R$ ${Number(v || 0).toFixed(2)}`

  // Agrupamento por categoria — baseado nos parcelados ativos (excl. cancelados)
  const statsPorCategoria = useMemo(() => {
    if (!dados?.detalheParcelados) return {}
    const stats = {}
    dados.detalheParcelados.forEach(d => {
      if (!["em_andamento", "inadimplente"].includes(d.status)) return
      const cat = d.categoria || "Sem categoria"
      if (!stats[cat]) stats[cat] = { pedidos: 0, senhas: 0 }
      stats[cat].pedidos++
      stats[cat].senhas += (d.senhas || []).length
    })
    return Object.fromEntries(
      Object.entries(stats).sort(([a], [b]) => a.localeCompare(b))
    )
  }, [dados])

  const categoriasDisponiveis = Object.keys(statsPorCategoria)

  const detalheFiltrado = dados
    ? dados.detalheParcelados
        .filter(d => {
          // "todos" = tudo menos cancelados; "cancelado" = só cancelados
          if (filtroStatus === "cancelado") return d.status === "cancelado"
          if (filtroStatus === "todos")     return d.status !== "cancelado"
          return d.status === filtroStatus
        })
        .filter(d => {
          const termo = busca.trim().toLowerCase()
          if (!termo) return true
          const nomeVaq  = (d.nomeVaqueiro || d.vaqueiro || "").toLowerCase()
          const nomeUsr  = (d.nomeUsuario || "").toLowerCase()
          const email    = (d.email || "").toLowerCase()
          const cpf      = (d.cpf || "").replace(/\D/g, "")
          const cpfTermo = termo.replace(/\D/g, "")
          const senhaMatch = (d.senhas || []).some(n => String(n).includes(termo))
          const cpfMatch = cpfTermo.length >= 3 && cpf.includes(cpfTermo)
          return nomeVaq.includes(termo) || nomeUsr.includes(termo) ||
                 email.includes(termo) || senhaMatch || cpfMatch
        })
        .filter(d => filtroCategoria === "todas" || d.categoria === filtroCategoria)
    : []

  return (
    <div className="admin-page-wrapper">
    <div style={{ padding: "24px 20px", maxWidth: 1200, margin: "0 auto", color: C.text }}>

      {/* Header */}
      <div style={{ marginBottom: 28 }}>
        <h2 style={{ display: "flex", alignItems: "center", gap: 10, color: C.gold, fontSize: 22, fontWeight: 700, margin: 0 }}>
          <FaLayerGroup /> Parcelamentos
        </h2>
        <p style={{ color: C.muted, marginTop: 6, fontSize: 14 }}>
          Acompanhe a receita realizada e a receber de cada evento com boleto parcelado ativo.{" "}
          <span style={{ color: C.borderGold, fontSize: 12 }}>
            Clique em uma linha para ver as parcelas detalhadas.
          </span>
        </p>
      </div>

      {/* Barra de controles */}
      <div style={{
        display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap",
        marginBottom: 28, padding: "16px 20px",
        background: C.card, borderRadius: 12, border: `1px solid ${C.border}`,
      }}>
        <FaFilter style={{ color: C.muted, flexShrink: 0 }} />
        <select
          value={eventoSelecionado}
          onChange={e => setEventoSelecionado(e.target.value)}
          disabled={loadingEventos}
          style={{
            flex: 1, minWidth: 220, padding: "9px 14px",
            background: C.input, border: `1px solid ${C.border}`,
            borderRadius: 8, color: C.text, fontSize: 14, outline: "none",
          }}
        >
          <option value="">{loadingEventos ? "Carregando eventos..." : "Selecione um evento"}</option>
          {eventos.map(ev => (
            <option key={ev._id} value={ev._id}>{ev.nome}</option>
          ))}
        </select>

        {eventoSelecionado && (
          <button onClick={exportarCSV} style={{
            display: "flex", alignItems: "center", gap: 6,
            background: `linear-gradient(to right, ${C.gold}, ${C.goldDark})`,
            color: "#121212", border: "none", borderRadius: 8,
            padding: "9px 18px", cursor: "pointer", fontWeight: 700, fontSize: 14, whiteSpace: "nowrap",
          }}>
            <FaFileDownload /> Exportar CSV
          </button>
        )}
      </div>

      {/* Erro ao alterar vencimento */}
      {erroVenc && (
        <div style={{
          padding: "12px 16px", marginBottom: 16, borderRadius: 8,
          background: "rgba(239,68,68,0.1)", border: `1px solid rgba(239,68,68,0.3)`,
          color: "#f87171", fontSize: 13, display: "flex", gap: 8, alignItems: "center",
        }}>
          ⚠️ {erroVenc}
          <button onClick={() => setErroVenc("")} style={{ marginLeft: "auto", background: "none", border: "none", color: "#f87171", cursor: "pointer" }}>✕</button>
        </div>
      )}

      {/* Loading */}
      {loading && (
        <div style={{ textAlign: "center", padding: 64, color: C.muted }}>
          <div style={{
            width: 36, height: 36, border: `3px solid ${C.border}`,
            borderTopColor: C.gold, borderRadius: "50%",
            animation: "spin 0.8s linear infinite", margin: "0 auto 16px",
          }} />
          <style>{`@keyframes spin { to { transform: rotate(360deg) } }`}</style>
          <p style={{ margin: 0 }}>Carregando dados...</p>
        </div>
      )}

      {/* Erro geral */}
      {erro && !loading && (
        <div style={{
          padding: "16px 20px", borderRadius: 10, textAlign: "center",
          background: "rgba(239,68,68,0.08)", border: `1px solid rgba(239,68,68,0.2)`, color: "#f87171",
        }}>
          {erro}
        </div>
      )}

      {/* Placeholder */}
      {!eventoSelecionado && !loading && (
        <div style={{
          textAlign: "center", padding: "64px 20px", color: C.muted,
          border: `2px dashed ${C.border}`, borderRadius: 12,
        }}>
          <FaChartBar size={40} style={{ marginBottom: 14, color: C.borderGold }} />
          <p style={{ fontSize: 16, fontWeight: 600, color: C.text, marginBottom: 6 }}>Selecione um evento</p>
          <p style={{ fontSize: 14 }}>Os dados de parcelamentos aparecerão aqui.</p>
        </div>
      )}

      {/* Dados */}
      {dados && !loading && (
        <>
          {/* Cards resumo — apenas métricas de boleto parcelado */}
          <div style={{
            display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(170px, 1fr))",
            gap: 14, marginBottom: 24,
          }}>
            <CardResumo
              titulo="Parcelamentos ativos"
              valor={dados.resumo.totalVendas}
              icone={<FaLayerGroup />}
              cor={C.text}
            />
            <CardResumo
              titulo="Total de senhas"
              valor={dados.resumo.totalSenhas ?? 0}
              icone={<FaTicketAlt />}
              cor={C.purple}
            />
            <CardResumo
              titulo="Receita total"
              valor={fmt(dados.resumo.receitaTotal)}
              icone={<FaMoneyBillWave />}
              cor={C.gold}
            />
            <CardResumo
              titulo="Receita realizada"
              valor={fmt(dados.resumo.receitaRealizada)}
              icone={<FaCheckCircle />}
              cor={C.green}
            />
            <CardResumo
              titulo="A receber"
              valor={fmt(dados.resumo.receitaAReceber)}
              icone={<FaHourglassHalf />}
              cor={C.blue}
            />
            <CardResumo
              titulo="Inadimplentes"
              valor={dados.parcelamentos.inadimplentes}
              icone={<FaExclamationTriangle />}
              cor={C.red}
            />
            <CardResumo
              titulo="Em atraso"
              valor={fmt(dados.resumo.valorAtrasado ?? 0)}
              icone={<FaClock />}
              cor="#f97316"
            />
          </div>

          {/* Breakdown */}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14, marginBottom: 24 }}>
            <div style={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: 12, padding: 18 }}>
              <p style={{ fontWeight: 700, margin: "0 0 10px", color: C.text, fontSize: 14 }}>💰 Financeiro geral pago</p>
              <p style={{ margin: 0, color: C.muted, fontSize: 13 }}>
                {dados.pagamentosUnicos.quantidade} vendas quitadas —{" "}
                <strong style={{ color: C.green }}>{fmt(dados.pagamentosUnicos.receita)}</strong>
              </p>
            </div>
            <div style={{ background: C.card, border: `1px solid ${C.borderGold}`, borderRadius: 12, padding: 18 }}>
              <p style={{ fontWeight: 700, margin: "0 0 10px", color: C.gold, fontSize: 14 }}>📋 Boletos parcelados em aberto</p>
              <p style={{ margin: "0 0 6px", fontSize: 13, color: C.muted, display: "flex", flexWrap: "wrap", gap: "0 8px" }}>
                <span>{dados.parcelamentos.total} inscrições em acompanhamento</span>
                <span style={{ color: C.blue }}>· {dados.parcelamentos.emAndamento} em andamento</span>
                <span style={{ color: C.red }}>· {dados.parcelamentos.inadimplentes} inadimplentes</span>
              </p>
              <p style={{ margin: 0, fontSize: 13 }}>
                Realizado: <strong style={{ color: C.green }}>{fmt(dados.parcelamentos.receitaRealizada)}</strong>
                {" "}· A receber: <strong style={{ color: C.blue }}>{fmt(dados.parcelamentos.receitaAReceber)}</strong>
              </p>
            </div>
          </div>

          {/* ── Grid por Categoria ─────────────────────────────────────── */}
          {categoriasDisponiveis.length > 0 && (
            <div style={{
              background: C.card, border: `1px solid ${C.border}`,
              borderRadius: 12, padding: "18px 20px", marginBottom: 16,
            }}>
              <p style={{ margin: "0 0 14px", fontWeight: 700, fontSize: 14, color: C.text, display: "flex", alignItems: "center", gap: 8 }}>
                <FaTicketAlt style={{ color: C.gold }} />
                Senhas parceladas por categoria
                {filtroCategoria !== "todas" && (
                  <button
                    onClick={() => setFiltroCategoria("todas")}
                    style={{ marginLeft: "auto", background: "none", border: `1px solid ${C.border}`, borderRadius: 6, padding: "3px 10px", color: C.muted, fontSize: 11, cursor: "pointer" }}
                  >
                    ✕ Limpar filtro
                  </button>
                )}
              </p>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
                {categoriasDisponiveis.map(cat => {
                  const s = statsPorCategoria[cat]
                  const ativo = filtroCategoria === cat
                  return (
                    <button
                      key={cat}
                      onClick={() => setFiltroCategoria(prev => prev === cat ? "todas" : cat)}
                      style={{
                        padding: "10px 16px",
                        background: ativo ? "rgba(255,204,0,0.12)" : "rgba(255,255,255,0.03)",
                        border: `1px solid ${ativo ? C.gold : C.border}`,
                        borderRadius: 10, cursor: "pointer", textAlign: "left",
                        transition: "all 0.15s",
                        outline: "none",
                        boxShadow: ativo ? `0 0 0 1px ${C.gold}` : "none",
                      }}
                    >
                      <div style={{ color: ativo ? C.gold : C.text, fontWeight: 700, fontSize: 13, whiteSpace: "nowrap" }}>
                        {cat}
                      </div>
                      <div style={{ marginTop: 5, display: "flex", gap: 10 }}>
                        <span style={{
                          fontSize: 11, fontWeight: 700,
                          color: ativo ? C.gold : C.muted,
                        }}>
                          {s.senhas} senha{s.senhas !== 1 ? "s" : ""}
                        </span>
                        <span style={{ fontSize: 11, color: C.muted }}>
                          · {s.pedidos} pedido{s.pedidos !== 1 ? "s" : ""}
                        </span>
                      </div>
                    </button>
                  )
                })}
              </div>
            </div>
          )}

          {/* Tabela */}
          <div style={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: 12, overflow: "hidden" }}>
            <div style={{
              display: "flex", justifyContent: "space-between", alignItems: "center",
              padding: "16px 20px", borderBottom: `1px solid ${C.border}`, flexWrap: "wrap", gap: 10,
            }}>
              <h3 style={{ margin: 0, color: C.text, fontSize: 15, fontWeight: 700 }}>
                Detalhe por vaqueiro
                {detalheFiltrado.length > 0 && (
                  <span style={{ marginLeft: 8, fontSize: 12, color: C.muted, fontWeight: 400 }}>
                    ({detalheFiltrado.length} resultado{detalheFiltrado.length !== 1 ? "s" : ""})
                  </span>
                )}
              </h3>

              {/* Controles de filtro */}
              <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>

                {/* Campo de busca */}
                <div style={{ position: "relative" }}>
                  <FaSearch style={{
                    position: "absolute", left: 10, top: "50%", transform: "translateY(-50%)",
                    color: C.muted, fontSize: 12, pointerEvents: "none",
                  }} />
                  <input
                    type="text"
                    placeholder="Vaqueiro, usuário, e-mail, CPF ou senha…"
                    value={busca}
                    onChange={e => setBusca(e.target.value)}
                    style={{
                      paddingLeft: 30, paddingRight: busca ? 28 : 12,
                      paddingTop: 7, paddingBottom: 7,
                      background: C.input, border: `1px solid ${C.border}`,
                      borderRadius: 8, color: C.text, fontSize: 13, outline: "none",
                      width: 210, transition: "border-color 0.2s",
                    }}
                    onFocus={e => e.target.style.borderColor = C.borderGold}
                    onBlur={e => e.target.style.borderColor = C.border}
                  />
                  {busca && (
                    <button
                      onClick={() => setBusca("")}
                      style={{
                        position: "absolute", right: 8, top: "50%", transform: "translateY(-50%)",
                        background: "none", border: "none", color: C.muted,
                        cursor: "pointer", fontSize: 12, lineHeight: 1, padding: 0,
                      }}
                    >✕</button>
                  )}
                </div>

                {/* Filtro de status */}
                <select
                  value={filtroStatus}
                  onChange={e => { setFiltroStatus(e.target.value); setBusca("") }}
                  style={{
                    padding: "7px 12px", background: C.input,
                    border: `1px solid ${filtroStatus === "cancelado" ? "rgba(239,68,68,0.5)" : C.border}`,
                    borderRadius: 8,
                    color: filtroStatus === "cancelado" ? C.red : C.text,
                    fontSize: 13, outline: "none",
                  }}
                >
                  <option value="todos">Ativos e concluídos</option>
                  <option value="em_andamento">Em andamento</option>
                  <option value="concluido">Concluídos</option>
                  <option value="inadimplente">Inadimplentes</option>
                  <option value="cancelado">Cancelados</option>
                </select>

                {/* Filtro de categoria */}
                {categoriasDisponiveis.length > 1 && (
                  <select
                    value={filtroCategoria}
                    onChange={e => setFiltroCategoria(e.target.value)}
                    style={{
                      padding: "7px 12px", background: C.input,
                      border: `1px solid ${filtroCategoria !== "todas" ? C.borderGold : C.border}`,
                      borderRadius: 8,
                      color: filtroCategoria !== "todas" ? C.gold : C.text,
                      fontSize: 13, outline: "none",
                    }}
                  >
                    <option value="todas">Todas as categorias</option>
                    {categoriasDisponiveis.map(cat => (
                      <option key={cat} value={cat}>{cat}</option>
                    ))}
                  </select>
                )}
              </div>
            </div>

            <div style={{ overflowX: "auto" }}>
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
                <thead>
                  <tr style={{ background: "rgba(255,204,0,0.08)" }}>
                    <th style={{ width: 36, borderBottom: `1px solid ${C.borderGold}` }} />
                    {["Vaqueiro", "Usuário", "Categoria", "Senhas", "Parcelas", "Realizado", "A Receber", "Próx. venc.", "Status", "Ação"].map(h => (
                      <th key={h} style={{
                        padding: "12px 16px", textAlign: "left", fontWeight: 600,
                        color: C.gold, fontSize: 12, textTransform: "uppercase",
                        letterSpacing: "0.5px", whiteSpace: "nowrap",
                        borderBottom: `1px solid ${C.borderGold}`,
                      }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {detalheFiltrado.length === 0 && (
                    <tr>
                      <td colSpan={11} style={{ textAlign: "center", padding: 40, color: C.muted }}>
                        {busca
                          ? `Nenhum resultado para "${busca}".`
                          : filtroStatus === "cancelado"
                            ? "Nenhum parcelamento cancelado neste evento."
                            : "Nenhum parcelamento encontrado para este filtro."
                        }
                      </td>
                    </tr>
                  )}

                  {detalheFiltrado.map((d, i) => {
                    const st       = STATUS_CFG[d.status] || { label: d.status, color: C.muted, bg: "transparent" }
                    const proxVenc = d.proximoPagamento
                      ? new Date(d.proximoPagamento).toLocaleDateString("pt-BR")
                      : "—"
                    const expandido = expandidoId === d.pedidoParceladoId
                    const rowBg     = expandido
                      ? "rgba(255,204,0,0.04)"
                      : i % 2 === 0 ? "transparent" : "rgba(255,255,255,0.02)"

                    return (
                      <React.Fragment key={d.pedidoParceladoId}>
                        {/* Linha principal clicável */}
                        <tr
                          onClick={() => toggleExpand(d.pedidoParceladoId)}
                          style={{
                            background: rowBg,
                            borderBottom: expandido ? `1px solid ${C.borderGold}` : `1px solid ${C.border}`,
                            cursor: "pointer",
                          }}
                        >
                          <td style={{ padding: "11px 6px 11px 14px", color: C.muted, verticalAlign: "middle" }}>
                            {expandido
                              ? <FaChevronUp size={11} style={{ color: C.gold }} />
                              : <FaChevronDown size={11} />
                            }
                          </td>

                          <td style={{ padding: "11px 16px", color: C.text, fontWeight: 600 }}>
                            {d.nomeVaqueiro || d.vaqueiro}
                          </td>

                          {/* Usuário que fez o pedido */}
                          <td style={{ padding: "11px 16px" }}>
                            <div style={{ color: C.text, fontWeight: 500, fontSize: 12 }}>
                              {d.nomeUsuario || "—"}
                            </div>
                            {d.email && (
                              <div style={{ color: C.muted, fontSize: 11, marginTop: 2 }}>
                                {d.email}
                              </div>
                            )}
                            {d.cpf && (
                              <div style={{ color: C.muted, fontSize: 11, fontFamily: "monospace" }}>
                                {d.cpf}
                              </div>
                            )}
                          </td>

                          <td style={{ padding: "11px 16px", color: C.muted }}>{d.categoria}</td>

                          <td style={{ padding: "11px 16px" }}>
                            {(d.senhas && d.senhas.length > 0) ? (
                              <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                                {d.senhas.map(num => (
                                  <span key={num} style={{
                                    background: "rgba(255,204,0,0.1)", border: `1px solid rgba(255,204,0,0.3)`,
                                    borderRadius: 4, padding: "2px 8px",
                                    fontSize: 12, fontWeight: 700, color: C.gold, whiteSpace: "nowrap",
                                  }}>#{num}</span>
                                ))}
                              </div>
                            ) : <span style={{ color: C.muted, fontSize: 12 }}>—</span>}
                          </td>

                          <td style={{ padding: "11px 16px" }}>
                            <span style={{ color: C.text, fontWeight: 700 }}>
                              {d.parcelasPagas}/{d.numeroParcelas}
                            </span>
                            {d.vencidas > 0 && (
                              <span style={{
                                marginLeft: 6, fontSize: 11, color: C.red,
                                background: "rgba(239,68,68,0.12)", padding: "1px 6px", borderRadius: 4,
                              }}>
                                {d.vencidas} venc.
                              </span>
                            )}
                          </td>

                          <td style={{ padding: "11px 16px", color: d.recebidoEstornado ? C.muted : C.green, fontWeight: 700 }}>
                            {fmt(d.realizadoNeste)}
                            {d.recebidoEstornado && (
                              <div style={{ color: C.red, fontSize: 10, fontWeight: 600, marginTop: 2 }}>
                                pago no histórico: {fmt(d.realizadoHistorico)} / reembolsado
                              </div>
                            )}
                          </td>

                          <td style={{ padding: "11px 16px", color: C.blue }}>
                            {fmt(d.aReceberNeste)}
                          </td>

                          <td style={{ padding: "11px 16px", color: C.muted, whiteSpace: "nowrap" }}>
                            {proxVenc}
                          </td>

                          <td style={{ padding: "11px 16px" }}>
                            <span style={{
                              background: st.bg, color: st.color,
                              padding: "3px 10px", borderRadius: 6,
                              fontSize: 12, fontWeight: 600, whiteSpace: "nowrap",
                            }}>{st.label}</span>
                          </td>

                          {/* Ação (stopPropagation para não abrir/fechar accordion) */}
                          <td style={{ padding: "11px 16px" }} onClick={e => e.stopPropagation()}>
                            {d.whatsapp ? (
                              <a
                                href={`https://wa.me/55${d.whatsapp.replace(/\D/g, "")}?text=Olá ${encodeURIComponent(d.nomeVaqueiro || d.vaqueiro)}, sua próxima parcela vence em ${proxVenc}. Acesse o boleto pelo app Ticket do Vaqueiro.`}
                                target="_blank" rel="noopener noreferrer"
                                title="Cobrar via WhatsApp (geral)"
                                style={{
                                  display: "inline-flex", alignItems: "center", justifyContent: "center",
                                  width: 34, height: 34, borderRadius: 8,
                                  background: "rgba(76,175,80,0.15)", color: C.green,
                                  fontSize: 18, textDecoration: "none",
                                }}>
                                <FaWhatsapp />
                              </a>
                            ) : <span style={{ color: C.muted }}>—</span>}
                          </td>
                        </tr>

                        {/* Linha expandida */}
                        {expandido && (
                          <tr style={{ borderBottom: `1px solid ${C.border}` }}>
                            <td colSpan={11} style={{ padding: 0, background: C.card2 }}>
                              <SubTabelaParcelas
                                parcelas={d.parcelas || []}
                                nomeVaqueiro={d.nomeVaqueiro || d.vaqueiro}
                                whatsapp={d.whatsapp}
                                nomeEvento={eventoAtual?.nome || ""}
                                pedidoParceladoId={d.pedidoParceladoId}
                                statusParcelamento={d.status}
                                editVenc={editVenc}
                                setEditVenc={setEditVenc}
                                onSalvarVenc={alterarVencimento}
                                salvandoVenc={salvandoVenc}
                                onCancelar={cancelarPedidoParcelado}
                                cancelando={cancelandoId === d.pedidoParceladoId}
                                onCobrarVencida={enviarCobrancaVencida}
                                enviandoCobr={enviandoCobr}
                                cobradoOk={cobradoOk}
                              />
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    )
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
    </div>
    </div>
  )
}